import { toast } from "react-toastify";

import API from "Services/Api";

export async function getCardOperators() {
  try {

    const data = await API.get(`/orders/card/operators`)

    return data.data
  } catch (error: any) {
    if (error.response) {
      const { status, data } = error.response;

      // Tratamento de erro 404
      if (status === 404) {
        toast.error(data.message);
      }

      // Tratamento de erro 500
      if (status === 500) {
        toast.error(
          "Ocorreu ao buscar as bandeiras do cartão."
        );
      }
    }
  }
}